module.exports = __webpack_public_path__ + "static/media/apple-motion.f4005503.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/apple-motion.svg
// module id = 2076
// module chunks = 0